import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mobile-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileNav = _resolveComponent("MobileNav")!
  const _component_MobileMenu = _resolveComponent("MobileMenu")!
  const _component_MobileMainContainer = _resolveComponent("MobileMainContainer")!
  const _component_MobileFooter = _resolveComponent("MobileFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_MobileNav),
      _createVNode(_component_MobileMenu)
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MobileMainContainer, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }),
      _createVNode(_component_MobileFooter)
    ])
  ], 64))
}